export default function delivery() {

  /* YouTube 埋め込み
  ----------------------------------------------------------------- */
  if (document.getElementById('js-youtube') != null) {
    /* Element */
    var youtubeWrap = document.getElementById('js-youtube');
    var youtubeTarget = document.getElementById('js-youtubeCont');
    var youtubeUrl = youtubeTarget.getAttribute('data-youtube');
    var youtubeId = youtubeUrl.split('v=')[1];

    /* iframe Player API */
    var ytPlayer;
    var youtubeTag = document.createElement('script');
    var youtubeScriptTag = document.getElementsByTagName('script')[0];
    youtubeTag.src = 'https://www.youtube.com/iframe_api';
    youtubeScriptTag.parentNode.insertBefore(youtubeTag, youtubeScriptTag);

    /* Default class */
    youtubeWrap.classList.add('c-delivery');

    /* Thumbnail */
    youtubeWrap.insertAdjacentHTML('beforeend', '<div class="c-delivery__thumb"><img src="http://i.ytimg.com/vi/' + youtubeId + '/maxresdefault.jpg"><i class="icon-play__btn"></i></div>');

    /* Set up */
    function setup() {
      return new Promise(resolve => {
        window.onYouTubeIframeAPIReady = function () {
          resolve(YT);
        }
      });
    }

    /* Set up 発火 */
    setup().then(YT => {
      // js-youtubeをクリック時に発火
      youtubeWrap.addEventListener('click', function () {
        ytPlayer = new YT.Player(
          // 埋め込む場所の指定
          'js-youtubeCont', {
            videoId: youtubeId, // YouTubeのID
            playerVars: {
              rel: 0, // 関連動画非表示
              showinfo: 0 // 動画情報非表示
            },
            events: {
              'onReady': onPlayerReady,
              // 'onStateChange': onPlayerStateChange
            }
          }
        );
        $('.c-delivery__thumb').remove();
      });
    });

    /* プレーヤー読み込み後の処理 */
    function onPlayerReady(event) {
      event.target.playVideo();
    }

    /* プレーヤー状態が変更時の処理 */
    /*
    function onPlayerStateChange(event) {
      // 現在のプレーヤー状態取得
      var youtubeStatus = event.data;
      // アイコン取得
      var youtubeIcon = $('.icon-play__btn');
      if (youtubeStatus == YT.PlayerState.PAUSED) {
        // 一時停止時
        youtubeWrap.insertAdjacentHTML('beforeend', '<i class="icon-play__btn"></i>');
      } else if (youtubeStatus == YT.PlayerState.PLAYING) {
        // アイコン非表示
        youtubeIcon.remove();
      }
    }
    */
  }

  /* Vimeo 埋め込み
  ----------------------------------------------------------------- */
  if (document.getElementById('js-vimeo') != null) {
    /* Element */
    var vimeoWrap = document.getElementById('js-vimeo');
    var vimeoTarget = document.getElementById('js-vimeoCont');
    var vimeoUrl = vimeoTarget.getAttribute('data-vimeo');
    var vimeoId = vimeoUrl.split('com/')[1];

    /* iframe Player API */
    var vimeoTag = document.createElement('script');
    var vimeoScriptTag = document.getElementsByTagName('script')[0];
    vimeoTag.src = 'https://player.vimeo.com/api/player.js';
    vimeoScriptTag.parentNode.insertBefore(vimeoTag, vimeoScriptTag);

    /* Default class */
    vimeoTarget.classList.add('c-delivery');

    /* Thumbnail (vimeoが非公開だと404になる) */
    // $.getJSON('https://www.vimeo.com/api/v2/video/' + vimeoId + '.json?callback=?', {format: "json"}, function (data) {
    //   vimeoWrap.insertAdjacentHTML('beforeend', '<div class="c-delivery__thumb"><img src=' + data[0].thumbnail_large + '><i class="icon-play__btn"></i></div>');
    // })

    /* Set up 発火 */
    setTimeout(function () {
      // プレーヤーオプション設定
      var options = {
        id: vimeoId, // VimeoのID
        byline: false, // 投稿者部分の表示
        portrait: false, // 左上のVimeoのマークの表示
        title: false // タイトルの表示
      };

      // プレーヤー読み込み後の処理
      var player = new Vimeo.Player('js-vimeoCont', options);

      // js-vimeoをクリック時に発火
      vimeoWrap.addEventListener('click', function () {
        $('.c-delivery__thumb').remove();
        player.play().then();
      });

      /*
      // 再生時に発火
      player.on('play', function () {
        // アイコン取得
        var vimeoIcon = $('.icon-play__btn');
        // アイコン非表示
        vimeoIcon.remove();
      });

      // 一時停止時に発火
      player.on('pause', function () {
        vimeoWrap.insertAdjacentHTML('beforeend', '<i class="icon-play__btn"></i>');
      });
      */
    }, 1000);
  }

}